import { isMatic, MaticNativeCurrency, ExtendedEther } from '../constants/tokens'

export default function useNativeCurrency(chainId: number) {
    return isMatic(chainId) ? new MaticNativeCurrency(chainId) : ExtendedEther.onChain(chainId)
}
